import { FunctionComponent } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { useConfirmCancelForm } from '@cbridge-modules/unsaved-changes-confirmation';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { useHasChanges } from '@cbridge-tools/form';
import { useFormContext } from 'react-hook-form';
import { IDetailsSidebarHeaderProps } from './DetailsSidebarHeader.interface';
import { DetailsSidebarHeader } from './DetailsSidebarHeader';

export const DetailsFormSidebarHeader: FunctionComponent<IDetailsSidebarHeaderProps> = ({ onClose, ...rest }) => {
  const dispatch = useDispatch();

  const { reset } = useFormContext();
  const hasChanges = useHasChanges();

  const { confirmCloseForm } = useConfirmCancelForm();

  const handleClose = async () => {
    if (!hasChanges || (await confirmCloseForm())) {
      reset();
      if (onClose) {
        onClose();
      } else {
        dispatch(DetailsSidebarAction.close());
      }
    }
  };

  return (
    <DetailsSidebarHeader {...rest} onClose={handleClose} />
  );
};
